import { eflowApi } from "../../lib/api";
export const createChargerAssetLink = async (requestBody) => {
    const { data } = await eflowApi.post("/assets/chargers/links", requestBody);
    return data;
};
export const getChargerAssetLinks = async (requestBody, cursor, limit, skip, orderBy, sortBy) => {
    const params = new URLSearchParams();
    if (cursor)
        params.append("cursor", cursor);
    if (limit !== undefined)
        params.append("limit", String(limit));
    if (skip !== undefined)
        params.append("skip", String(skip));
    if (orderBy && orderBy.length > 0)
        params.append("orderBy", orderBy.join(","));
    if (sortBy && sortBy.length > 0)
        params.append("sortBy", sortBy.join(","));
    const queryString = params.toString();
    const url = `/assets/chargers/links/search${queryString ? `?${queryString}` : ""}`;
    const { data } = await eflowApi.post(url, requestBody);
    return data;
};
